import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface Login {
  email: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "login",
  initialState: {} as SliceState<Login>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const createLoginFormReducer = formSlice.reducer;
export default createLoginFormReducer;
